<template>
    <div class="tools-tab tools-tab-sick">
        <div class="empty is-visible" v-if=" ! item.shift && ! item.times">
        {{ $t('page.roster.tools.sick.needs_time') }}
        </div>

        <div v-else>
            <div class="box-note" v-if=" ! user.billable && ! $onduro.getConfig('hours.everyone')" style="font-size:12px;color:#c9635b">
                {{ $t('page.roster.tools.sick.no_costs') }}
            </div>

            <div class="box-note" v-show="user.payroll">
                {{ $t('page.roster.tools.sick.payroll_payment') }}
            </div>

            <div v-if="$current.profile == 'SKO'">
                <div class="box-note">
                    {{ $t('page.roster.tools.sick.sko') }}
                </div>
                <select v-model="form.code" style="width:280px">
                    <option v-for="(name, id) in codes" :value="id">{{ name }}</option>
                </select>
                <error :message="$v.message('code')" style="color:#c9635b" />
            </div>

            <template v-else>
                <div v-if=" ! user.payroll">
                    <div v-if="$onduro.hasModule('balances')">
                        <div class="box-note" v-if="user.balance && form.percentage != '100'">{{ $t('page.roster.tools.sick.balance_note') }}</div>
                        <div class="box-note" v-else>{{ $t('page.roster.tools.sick.hint') }}</div>
                    </div>
                    <div v-else class="box-note">{{ $t('page.roster.tools.sick.hint') }}</div>
                    <strong>{{ $t('page.roster.tools.sick.payment') }}</strong>
                    <select v-model="form.percentage">
                        <option v-for="(percentage, key) in percentages" :value="key">{{ percentage }}</option>
                    </select>
                </div>

                <div style="margin-top:15px" v-if="$onduro.hasModule('costs') && user.costs && user.costs.length > 1">
                    <strong>{{ $t('label.cost') }}</strong>
                    <select v-model="form.cost">
                        <option v-for="cost in user.costs" :value="cost.id">{{ cost.name }}</option>
                    </select>
                </div>
            </template>

            <a href="#" class="unmark" v-on:click.prevent="removeSickness" v-if="sick">{{ $t('page.roster.tools.sick.undo') }}</a>
            <a href="#" class="box-button" v-on:click.prevent="saveSickness">{{ $t('page.roster.tools.sick.apply') }}</a>
        </div>
    </div>
</template>

<script>
// import events from '../../../events/events';
import shared from '../../../pages/planning/shared';

export default
{
    name: 'Sick',

    props: ['item'],

    data() {
        return {
            form:
            {
                cost: null,
                percentage: 100,
                code: null,
            },
            percentages:
            {
                100: '100%',
                95: '95%',
                90: '90%',
                85: '85%',
                80: '80%',
                75: '75%',
                70: '70%',
                65: '65%',
                60: '60%',
                55: '55%',
                50: '50%',
                45: '45%',
                40: '40%',
                35: '35%',
                30: '30%',
                25: '25%',
                20: '20%',
                15: '15%',
                10: '10%',
                5: '5%',
                0: '0%',
            },
            codes:
            {
                11: 'Kinderpflege mit Krankengeld',
                14: 'vollst. Freistellung für Betreuung/Begleitung Pflegebedürftiger',
                15: 'Pflegezeit mit vollständiger Freistellung',
                16: 'Kurzzeitige Pflege',
                19: 'unwiderrufliche unbezahlte Freistellung',
                21: 'Unbezahlter Urlaub',
                22: 'Unbezahlte Fehlzeit',
                23: 'Unrechtmäßiger Streik',
                24: 'Kinderpflege ohne Krankengeld',
                25: 'Krank privat Versicherte ohne Krankentagegeld',
                26: 'Krank über 6 Wochen bei Erwerbsminderungs-/Altersrente',
                27: 'Krank über 6 Wochen geringfügig entlohnter AN.',
                28: 'Aussteuerung',
                29: 'Einstellung Krankengeld w. voller Erwerbsm. Rente',
                31: 'Rechtmäßiger Streik',
                32: 'Aussperrung',
                33: 'Entgeltfortzahlung ohne AU-Bescheinigung',
                41: 'Kranken(tage)geld bei Krankheit oder Kur',
                42: 'Verletztengeld bei Krankheit oder Kur',
                43: 'Übergangsgeld bei Krankheit oder Kur',
                44: 'Versorgungskrankengeld bei Krankheit oder Kur',
                45: 'Mutterschutzfrist',
                47: 'Krank bei Eintritt ohne Entgeltfortzahlung',
                51: 'Elternzeit',
                61: 'Wehrdienst',
                62: 'Zivildienst',
                63: 'Wehrübung',
                64: 'Eignungsübung',
                81: 'KUG/S-KUG Krank',
                103: 'Entgeltfortzahlung mit AU-Bescheinigung',
                105: 'unwiderrufliche bezahlte Freistellung',
                106: 'Studienzeit (dualer Studiengang)',
                200: 'Kinderpflege mit Entgeltfortzahlung',
                201: 'Kinderpflege bei Schwersterkrankung',
                210: 'Pflegeunterstützungsgeld',
                260: 'Ende Bezug Krankengeld/Beginn Bezug Arbeitslosengeld',
                300: 'Entgeltfortzahlung wegen Organ-/Gewebespende',
                301: 'Freistellung im Rahmen sonstiger flexibler Arbeitszeitregelungen',
                302: 'Krankengeld bei Organ-/Blut/Gewebespende ohne EEL',
            }
        }
    },

    created()
    {
        this.init();
    },

    watch:
    {
        item()
        {
            this.init();
        }
    },

    computed:
    {
        user()
        {
            return shared.getUser(this.item.user);
        },

        sick()
        {
            return (this.item) ? this.item.flag == 'sick' : false;
        },
    },

    methods:
    {
        init()
        {
            // set default cost for user
            if (this.user.costs.length)
            {
                this.form.cost = this.user.costs[0].id;
            }

            if (this.item.hour)
            {
                // only set defaults if they have been set before
                if (this.item.hour.cost) this.form.cost = this.item.hour.cost;
                if (this.item.hour.code) this.form.code = this.item.hour.code;
                if (typeof this.item.hour.billable != 'undefined') this.form.percentage = this.item.hour.billable;
            }
        },

        saveSickness()
        {
            this.$http.put('/api/items/' + this.item.id + '/sick', this.form)
            .then(response =>
            {
                this.item.flag = 'sick';
                this.item.hour = {
                    billable: this.form.percentage,
                    cost: this.form.cost,
                    code: this.form.code,
                };

                this.$tools.close();
            })
            .catch(error =>
            {
                switch (error.response.data.error)
                {
                    case 'ERR_TIME':
                        this.$modal.show(this.$t('page.roster.sick.ERR_TIME.headline'), this.$t('page.roster.sick.ERR_TIME.text'));
                    break;

                    case 'ERR_COST':
                        alert('Invalid cost!');
                    break;

                    case 'ERR_HOURS':
                        this.$confirm.show(this.$t('page.roster.sick.ERR_HOURS.headline'), this.$t('page.roster.sick.ERR_HOURS.text'), 
                        {
                            confirm: () => 
                            {
                                this.$http.put('/api/items/' + this.item.id + '/sick', Object.assign(this.form, {
                                    force: true
                                }))
                                .then(response =>
                                {
                                    this.item.flag = 'sick';
                                    this.item.hour = {
                                        billable: this.form.percentage,
                                        cost: this.form.cost,
                                        code: this.form.code,
                                    };

                                    this.$tools.close();
                                })
                            }
                        });
                    break;
                }

                if (error.response.status == 422 && error.response.data)
                {
                    this.$v.setErrors(error.response.data);
                }
            });
        },

        removeSickness()
        {
            this.$http.delete('/api/items/' + this.item.id + '/sick', this.form)
            .then(response =>
            {
                this.item.flag = null;
                this.item.hour = null;

                this.$tools.close();
            });
        },
    },
}
</script>



// WEBPACK FOOTER //
// Sick.vue?5fb3d4ff